<template>
  <div>
    <div class="d-flex flex-row">

      <div class="col" v-if="!isMultiple">
        <p class="font-16 font-weight-bold mt-2">
          {{ $resourceString["checkout.Title.DeliveryOption"] }} :
        </p>
        <!-- priority -->
        <div class="d-flex flex-row form-check my-2">
          <input @click="setCurbsideFalse" class="form-check-input" type="radio" id="standard" name="ship"
            value="Standard" checked v-model="shippingOption" />
          <label class="font-16 font-weight-bold ml-2 form-check-label" for="standard">
            {{ $resourceString["checkout.Shipping.Standard"] }} <br />
            <span class="font-weight-normal">{{
              $resourceString["checkout.Shipping.Standard.Description"]
            }}</span>
          </label>
        </div>
        <!-- second day -->
        <div class="d-flex flex-row form-check my-2">
          <input @click="setCurbsideFalse" class="form-check-input" type="radio" id="second" name="ship"
            value="SecondDay" v-model="shippingOption" />
          <label class="font-16 font-weight-bold ml-2 form-check-label" for="second">
            {{ $resourceString["checkout.Shipping.SecondDay"] }} <br />
            <span class="font-weight-normal">{{
              $resourceString["checkout.Shipping.SecondDay.Description"]
            }}</span>
          </label>
        </div>
        <!-- ground -->
        <div class="d-flex flex-row form-check my-2">
          <input @click="setCurbsideFalse" class="form-check-input" type="radio" id="ground" name="ship" value="Ground"
            v-model="shippingOption" />
          <label class="font-16 font-weight-bold ml-2 form-check-label" for="ground">
            {{ $resourceString["checkout.Shipping.Ground"] }} <br />
            <span class="font-weight-normal">{{
              $resourceString["checkout.Shipping.Ground.Description"]
            }}</span>
          </label>
        </div>

        <div v-if="zipcodeMatch && inStock" class="d-flex flex-row form-check mt-2">
          <img class="floorDashImg mt-4 mb-2"
            src="https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/floordash_pc_black.png" />
        </div>

        <div v-if="zipcodeMatch && this.showroomDeliveryAvailable && inStock" class="d-flex flex-row form-check mt-2">
          <input @click="setCurbsideFalse" class="form-check-input" type="radio" id="sameDay" name="sameDay"
            value="sameDay" v-model="shippingOption" />
          <label class="font-16 font-weight-bold ml-2 form-check-label" for="sameDay">
            {{ $resourceString["checkout.Shipping.SameDay"] }} <br />
            <span class="font-weight-normal">
              {{ $resourceString["checkout.Shipping.SameDay.Description"] }}
            </span>
          </label>
        </div>
        
        <div v-if="zipcodeMatch && this.showroomPickupAvailable && inStock" class="d-flex flex-column">
          <div class="d-flex flex-row form-check mt-2">
            <input @click="setCurbsideTrue" class="form-check-input" type="radio" id="localPickup" name="localPickup"
              value="localPickup" v-model="shippingOption" />
            <label class="font-16 font-weight-bold ml-2 mt-2" for="sameDay">
              {{ $resourceString["checkout.Shipping.LocalPickup"] }}
              <br />
              <span class="font-weight-normal">
                {{
                  $resourceString["checkout.Shipping.LocalPickup.Description"]
                }}
              </span>
            </label>
          </div>
        </div>

      </div>

      <div class="col" v-if="!isMultiple && inStock && zipcodeMatch">
        <p class="font-16 font-weight-bold mt-2">
          Nearest Patcraft Showroom:
        </p>
        <p class="font-16">
          {{ this.showrooms[this.showroomCounter].addressLine1 }} <br />
          {{ this.showrooms[this.showroomCounter].addressLine2 }} <br />
          {{ this.showrooms[this.showroomCounter].city }} <br />
          Phone: {{ this.showrooms[this.showroomCounter].phone }} <br />
          Hours Today: {{ this.showrooms[this.showroomCounter].hours }}
        </p>
      </div>
    </div>
    
    <div v-if="!isMultiple && this.curbside">
      <div class="d-flex flex-row mb-4">
        <div class="d-flex flex-column">
          <label for="make" class="font-16">Vehicle Make:</label>
          <input :required="curbside" id="make" placeholder="Enter Vehicle Make" class="form-control"
            v-model="createStudio.vehicleMake" />
        </div>
        <div class="d-flex flex-column">
          <label for="model" class="font-16">Vehicle Model:</label>
          <input :required="curbside" id="model" placeholder="Enter Vehicle Model" class="form-control"
            v-model="createStudio.vehicleModel" />
        </div>
        <div class="d-flex flex-column">
          <label for="color" class="font-16">Vehicle Color:</label>
          <input :required="curbside" id="color" placeholder="Enter Vehicle Color" class="form-control"
            v-model="createStudio.vehicleColor" />
        </div>
      </div>
    </div>

    <div class="d-flex flex-column font-weight-light font-16">
      <div class="d-flex d-row font-weight-bold font-16" v-if="isMultipleAddressCheckout">
        Shipping Option:
        <div class="font-weight-light pl-1">
          {{ getShippingOptionName(multipleItemShippingOption[itemIndex]) }}
        </div>
      </div>
      <a v-if="isMultipleAddressCheckout" href="#" class="font-16 mt-1 danger" data-toggle="modal"
        data-backdrop="static" :data-target="'#dashModal' + itemIndex" :ref="'deliveryAddressModal' + itemIndex"
        @click="openShippingOption()">
        Change Delivery Option
      </a>
    </div>

    <!-- Dash Shipping Modal -->
    <div class="modal fade" :id="'dashModal' + itemIndex" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content dashModal">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $resourceString["checkout.Create.Title"] }}
            </h5>
            <button class="wf-modal-button-close btn button-full" type="button" data-dismiss="modal" aria-label="Close"
              ref="close">
              <span class="png-icon png-icon-icons-symbols--k-txtclose" aria-label="Close modal" />
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-row">
              <div class="d-flex flex-column">
                <h6 class="font-weight-bold">
                  {{ $resourceString["checkout.Create.Delivery"] }}
                </h6>
                <div class="d-flex flex-column">
                  <div class="d-flex flex-row form-check mt-2">
                    <input class="form-check-input" type="radio" id="second" :name="'deliveryAddress' + itemIndex"
                      value="SecondDay" checked v-model="shippingOption" />
                    <label class="font-16 font-weight-bold ml-2 form-check-label" for="second">
                      {{ $resourceString["checkout.Shipping.SecondDay"] }}
                      <br />
                      <span class="font-weight-normal">{{
                        $resourceString[
                        "checkout.Shipping.SecondDay.Description"
                        ]
                      }}</span>
                    </label>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="d-flex flex-row form-check mt-2">
                    <input class="form-check-input" type="radio" id="standard" :name="'deliveryAddress' + itemIndex"
                      value="Standard" v-model="shippingOption" />
                    <label class="font-16 font-weight-bold ml-2 form-check-label" for="standard">
                      {{ $resourceString["checkout.Shipping.Standard"] }} <br />
                      <span class="font-weight-normal">{{
                        $resourceString[
                        "checkout.Shipping.Standard.Description"
                        ]
                      }}</span>
                    </label>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="d-flex flex-row form-check mt-2">
                    <input class="form-check-input" type="radio" id="ground" :name="'deliveryAddress' + itemIndex"
                      value="Ground" v-model="shippingOption" />
                    <label class="font-16 font-weight-bold ml-2 form-check-label" for="ground">
                      {{ $resourceString["checkout.Shipping.Ground"] }} <br />
                      <span class="font-weight-normal">{{
                        $resourceString["checkout.Shipping.Ground.Description"]
                      }}</span>
                    </label>
                  </div>
                </div>
                <div v-if="zipcodeMatch" class="d-flex flex-column">
                  <div class="d-flex flex-row form-check mt-2">
                    <input class="form-check-input" type="radio" id="sameDay" :name="'deliveryAddress' + itemIndex"
                      value="sameDay" v-model="shippingOption" />
                    <label class="font-16 font-weight-bold ml-2 form-check-label" for="sameDay">
                      {{ $resourceString["checkout.Shipping.SameDay"] }} <br />
                      <span class="font-weight-normal">
                        {{
                          $resourceString[
                          "checkout.Shipping.SameDay.Description"
                          ]
                        }}
                      </span>
                    </label>
                  </div>
                </div>
                <div v-if="zipcodeMatch" class="d-flex flex-column">
                  <div class="d-flex flex-row form-check mt-2">
                    <input class="form-check-input" type="radio" id="localPickup" :name="'deliveryAddress' + itemIndex"
                      value="localPickup" v-model="shippingOption" />
                    <label class="font-16 font-weight-bold ml-2 mt-2" for="sameDay">
                      {{ $resourceString["checkout.Shipping.LocalPickup"] }}
                      <br />
                      <span class="font-weight-normal">
                        {{
                          $resourceString[
                          "checkout.Shipping.LocalPickup.Description"
                          ]
                        }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-start pt-4">
              <button @click="updateMultipleShippingOption" type="button" class="btn btn-primary" data-dismiss="modal">
                {{ $resourceString["checkout.Create.Select.Button"] }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    isMultiple: {
      required: true
    },
    itemIndex: {
      required: false
    },
    shippingOptionData: {
      required: true
    },
    zCode: {
      required: false
    },
    createStudio: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      shippingOption: this.shippingOptionData,
      zipcodeMatch: false,
      showroomCounter: 0,
      showroomID: "",
      showroomCodeName: "",
      showroomDeliveryAvailable: false,
      showroomPickupAvailable: false,
      showroomInventory: [],
      cartInventory: [],
      curbside: false
    };
  },
  mounted() {
    this.showroomsAsync();
  },
  computed: {
    ...mapGetters({
      isMultipleAddressCheckout: "checkoutPage/getMultipleAddressCheckout",
      multipleItemShippingOption: "checkoutPage/getMultipleItemShippingOption",
      checkoutData: "checkoutPage/checkoutData",
      showrooms: "checkoutPage/showrooms",
      showroomLocations: "checkoutPage/showroomLocations",
      gimbleData: "checkoutPage/gimbleData",
      inStock: "checkoutPage/inStock"
    })
  },
  watch: {
    showroomCodeName(code, oldCode) {
      this.createStudio.warehouseCode = code;
      this.gimbleJSON(code);
    },
    shippingOptionData() {
      this.createStudio.deliveryMethod = this.shippingOptionData;
      this.shippingOption = this.shippingOptionData;
    },
    shippingOption(newOption, oldOption) {
      this.setShippingOption(newOption);
    },
    zCode() {
      if (this.zCode !== undefined && this.zCode !== null) {
        this.checkZipcodeMatch();
      }
    }
  },
  methods: {
    ...mapActions({
      setShippingOption: "checkoutPage/setShippingOption",
      setMultipleItemShippingOption:
        "checkoutPage/setMultipleItemShippingOption",
      getShowrooms: "checkoutPage/getShowrooms",
      getShowroomLocations: "checkoutPage/getShowroomLocations",
      getGimbleServiceData: "checkoutPage/getGimbleServiceData",
      setInStock: "checkoutPage/setInStock"
    }),
    updateMultipleShippingOption() {
      let data = {
        listIndex: this.itemIndex,
        value: this.shippingOption
      };
      this.setMultipleItemShippingOption(data);
    },
    openShippingOption() {
      this.shippingOption = this.multipleItemShippingOption[this.itemIndex];
    },
    getShippingOptionName(value) {
      if (value == "SecondDay") {
        return this.$resourceString["checkout.Shipping.SecondDay"];
      } else if (value == "Standard") {
        return this.$resourceString["checkout.Shipping.Standard"];
      } else if (value == "Ground") {
        return this.$resourceString["checkout.Shipping.Ground"];
      } else if (value == "sameDay") {
        return this.$resourceString["checkout.Shipping.SameDay"];
      } else if (value == "localPickup") {
        return this.$resourceString["checkout.Shipping.LocalPickup"];
      }
    },
    updateZipcodeTrue() {
      this.zipcodeMatch = true;
    },
    updateZipcodeFalse() {
      this.zipcodeMatch = false;
    },
    checkZipcodeMatch() {
      // Check if zCode is defined and not null
      if (this.zCode !== undefined && this.zCode !== null) {
        if (Array.isArray(this.showroomLocations)) {
          for (const e of this.showroomLocations) {
            if (e && e.postalCode == this.zCode) {
              this.updateZipcodeTrue();
              this.showroomID = e.showroomID;

              //get showroomCode of matching showroom location
              for (let i = 0; i < this.showrooms.length; i++) {
                if (this.showroomID == this.showrooms[i].showroomID) {
                  this.showroomCounter = i;
                  this.showroomCodeName = this.showrooms[i].showroomCodeName;

                  //get delivery options of matching showroom
                  for (let i = 0; i < this.showrooms.length; i++) {
                    if (
                      this.showroomCodeName ==
                      this.showrooms[i].showroomCodeName
                    ) {
                      this.showroomDeliveryAvailable = this.showrooms[
                        i
                      ].delivery;
                      this.showroomPickupAvailable = this.showrooms[i].pickup;
                    }
                  }
                }
              }
              return;
            }
          }
        }
      }
      // If no match found or there's an issue, update the flag to false
      this.updateZipcodeFalse();
    },
    setCurbsideTrue() {
      this.curbside = true;
    },
    setCurbsideFalse() {
      this.curbside = false;
    },
    setCartInventory() {
      //loop through this.checkoutData.Items
      for (let i = 0; i < this.checkoutData.Items.length; i++) {
        let cartProduct = {
          style: this.checkoutData.Items[i].GTMProduct.SellingStyleNumber,
          color: this.checkoutData.Items[i].GTMProduct.SellingColorNumber,
          quantity: this.checkoutData.Items[i].GTMProduct.Quantity
        };
        this.cartInventory.push(cartProduct);
      }
    },
    setShowroomInventory() {
      // Check if gimbleData and product are defined and not null
      if (this.gimbleData && this.gimbleData.product) {
        // Loop through gimbleData.product
        for (let i = 0; i < this.gimbleData.product.length; i++) {
          if (
            this.gimbleData.product[i].style &&
            this.gimbleData.product[i].color &&
            this.gimbleData.product[i].inventory &&
            this.gimbleData.product[i].inventory[0]
          ) {
            let showroomProduct = {
              style: this.gimbleData.product[i].style,
              color: this.gimbleData.product[i].color,
              // Check if quantity is defined and not null
              quantity: this.gimbleData.product[i].inventory[0].quantity || 0
            };

            this.showroomInventory.push(showroomProduct);
          }
        }
      }
    },
    checkShowroomInventory() {
      //compare cartInventory and showroomInventory
      for (let i = 0; i < this.cartInventory.length; i++) {
        let cartItem = this.cartInventory[i];

        let showroomItem = this.showroomInventory.find(
          item => item.style === cartItem.style && item.color === cartItem.color
        );

        if (showroomItem && cartItem.quantity > showroomItem.quantity) {
          this.setInStock(false);
          break;
        }
      }
    },
    async showroomsAsync() {
      try {
        await this.getShowrooms();
        await this.getShowroomLocations();
      } catch (error) {
        console.log("try showrooms err", error);
      }
    },
    async gimbleJSON(code) {
      let products = [];
      let items = this.checkoutData.Items;
      if (items != undefined && items != null) {
        this.checkoutData.Items.forEach(item => {
          if (item.GTMProduct) {
            let product = {
              style: item.GTMProduct.SellingStyleNumber,
              color: item.GTMProduct.SellingColorNumber
            };
            products.push(product);
          }
        });
      }
      let json = {
        warehouse: code,
        product: products
      };
      this.getGimbleAsync(json);
    },
    async getGimbleAsync(json) {
      await this.getGimbleServiceData(json);
      await this.setCartInventory();
      await this.setShowroomInventory();
      await this.checkShowroomInventory();
    }
  }
};
</script>

<style></style>
